import { styled } from '@mui/material/styles';
import { Box, Stack, SxProps } from '@mui/material';

// Components
import MapleTypography from 'Components/ds/MapleTypography';
import MapleIcon, { MapleIconProps } from 'Components/ds/MapleIcon';

interface StyledMapleProps {
  variant: 'primary' | 'warning' | 'error' | 'circleBlue';
  shade?: 'light' | 'dark';
}

const StyledMapleAlert = styled(Stack)<StyledMapleProps>(({ theme, variant, shade }) => ({
  padding: theme.spacing(1),
  borderRadius: theme.shape.sm,
  ...(shade === 'light' && {
    backgroundColor: theme.palette[variant].contrastText,
    color: theme.palette[variant].main,
  }),

  ...(shade === 'dark' && {
    backgroundColor: theme.palette[variant].main,
    color: theme.palette.text.strong,
  }),
}));

const closeButtonStyles = {
  position: 'absolute',
  right: 8,
  width: 18,
  height: 18,
};

export interface MapleAlertProps extends StyledMapleProps {
  title: string | React.ReactNode;
  justifyContent?: 'center' | 'flex-start';
  icon?: MapleIconProps['icon'];
  sx?: SxProps;
  closeable?: boolean;
  handleClose?: () => void;
  onClick?: () => void;
}

const MapleAlert = ({
  variant,
  title,
  icon,
  shade = 'light',
  justifyContent = 'center',
  sx,
  closeable = false,
  handleClose,
  onClick,
}: MapleAlertProps) => {
  return (
    <StyledMapleAlert
      variant={variant}
      shade={shade}
      direction='row'
      alignItems='center'
      justifyContent={justifyContent}
      spacing={1}
      sx={sx}
      onClick={onClick}
    >
      {icon && <MapleIcon height={12} width={14} icon={icon} />}
      <MapleTypography textAlign='center' variant='label' size='xSmall'>
        {title}
      </MapleTypography>
      {closeable && (
        <Box sx={closeButtonStyles} onClick={handleClose}>
          <MapleIcon icon='closeLine' color='icon.white' size={18} />
        </Box>
      )}
    </StyledMapleAlert>
  );
};

export default MapleAlert;
